// this is a hack to access insertScript from window (see index.html)
// there are more idiomatic ways to do this, in theory, (e.g.
// https://benny.work/2019/02/20/2/) but I had trouble getting them to work
const insertScript: (url: string) => Promise<void> = (window as any)
  .insertScript;
export default insertScript;
